import React from "react";

import { Image, Text } from "../../atoms";

export const PictureAndText = props => {
	const { imageUrl, text } = props;

	return (
		<div className="picture-and-text flex -al-c">
			<Image src={imageUrl} circle />
			<Text>{text}</Text>
		</div>
	);
};


// WEBPACK FOOTER //
// src/molecules/lib/PictureAndText.js